export const fetchData = (data) => {
    return {
        type: "FETCH_DATA",
        payload: data
    };
};
export const addItem = (data) => {
    return {
        type: "ADD_ITEM",
        payload: data
    };
};
export const editItem = (data) => {
    return {
        type: "EDIT_ITEM",
        payload: data
    };
};
export const deleteItem = (data) => {
    return {
        type: "DELETE_ITEM",
        payload: data
    };
};